import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceType } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-disabled-service-modal',
  templateUrl: './disabled-service-modal.component.html',
  styleUrl: './disabled-service-modal.component.scss',
  standalone: false
})
export class DisabledServiceModalComponent {
  @Input() service: ServiceType = null;
  constructor(public activeModal: NgbActiveModal) {}
}

LightningModalTypes.DisabledServiceModalComponent.component = DisabledServiceModalComponent;
